module.exports = __webpack_public_path__ + "TB_Powerdown_Melody_B.wav.7453ed0d.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_down/TB_Powerdown_Melody_B.wav.mp3
// module id = 499
// module chunks = 0